import React from 'react'
import './styles.css'
import SvgIcon, { iconList } from '../../../share/components/iconSVG'

const WantMore = () => {
  return (
    <div className='contain-want-more'>
      <section className='card-want-more'>
        <div className='info-want-more'>
          <h2>
            Turismo en salud
          </h2>
          <p>
            En Wellezy tenemos para ti paquetes todo incluido
            con el enfoque en salud, estética y bienestar
          </p>
        </div>
        <button className='btn-want-more'>
            Conoce mas aqui
        </button>
      </section>
      <section className='card-want-more'>
        <div className='info-want-more'>
          <h2>
          ¿QUIERES MÁS?
          </h2>
          <p>
          Conoce nuestra tienda donde encontraras todo
sobre travel, salud, nuestros productos y más.
          </p>
        </div>
        <button className='btn-want-more'>
        <SvgIcon name={iconList.IconCartBuy} size={30} color={'#004274'}/> Tienda Wellezy
        </button>
      </section>
    </div>
  )
}

export default WantMore